import React, { useState, useEffect } from 'react';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import { useSelector } from 'react-redux';
import methodModel from '../../../methods/methods';
import { userType } from '../../../models/type.model';
import Html from './Html';
import { useNavigate, useParams } from 'react-router-dom';
import environment from '../../../environment';

const AddEditUser = () => {
  const { role, id } = useParams();
  const [images, setImages] = useState({ image: '', logo: '' });
  const defaultvalue = userType;
  const [form, setform] = useState({ role });
  const [eyes, setEyes] = useState({ password: false, confirmPassword: false });
  const [submitted, setSubmitted] = useState(false);
  const history = useNavigate();
  const [roles, setRoles] = useState([]);
  const [emailLoader, setEmailLoader] = useState(false);
  const [emailErr, setEmailErr] = useState('');
  const [detail, setDetail] = useState();
  const user = useSelector((state) => state.user);
  const formValidation = [
    // { key: 'mobileNo', minLength: 10 },
    { key: 'email', email: true },
    // { key: 'lastName', required: true },
    { key: 'firstName', required: true },

    // { key: 'ic_number', minLength: 6 },
    // { key: 'password', minLength: 8 },
  ];

  const getError = (key) => {
    return methodModel.getError(key, form, formValidation);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    let invalid = methodModel.getFormError(formValidation, form);
    if (!form?.email || !form?.role) {
      return;
    }
    if (invalid) return;
    let method = 'post';
    let url = 'admin/add-user';
    let value = {
      ...form,
    };
    value.role = form?.role;
    delete value.logo;
    if (value.id) {
      method = 'put';
      url = 'user/profile';
      delete value.role;
    } else {
      value.addedBy = user._id;
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        let url = '/users';
        if (role) url = '/users/' + role;
        history(url);
      }
      loader(false);
    });
  };

  const imageResult = (e, key) => {
    images[key] = e.value;
    setImages(images);
    setform({ ...form, image: e.value });
    console.log('imageResult', e);
  };

  const addressResult = (e) => {
    setform({ ...form, address: e.value });
  };

  const back = () => {
    history(-1);
  };

  const getRoles = () => {
    ApiClient.get('role/all', { status: 'active' }).then((res) => {
      if (res.success) {
        let data = res.data;
        data = data.filter((itm) => itm.id != environment.userRoleId);

        let ExtractRoles = res?.data?.filter(
          (itm) => itm?.id != 2 && itm?.id != 1
        );
        let filterData = ExtractRoles?.map((itm) => {
          return {
            id: itm?.role,
            name: methodModel.capitalizeFirstLetter(itm?.role === "coaches" ? "Coach" : itm?.role === "parents" ? "Parent" : itm?.role),
          };
        });

        console.log(filterData, '=========DATA');
        setRoles(filterData);
      }
    });
  };

  const emailCheck = (email) => {
    return;
    let isValid = methodModel.emailvalidation(email);
    if (isValid) {
      setEmailLoader(true);
      ApiClient.get('api/check/email', { email: email }).then((res) => {
        if (!res.success) {
          if (detail?.email != email) {
            setEmailErr(res.error.message);
          }
        } else {
          setEmailErr('');
        }
        setEmailLoader(false);
      });
    } else {
    }
  };

  useEffect(() => {
    setSubmitted(false);

    if (id) {
      loader(true);
      ApiClient.get('user/detail', { id }).then((res) => {
        if (res.success) {
          let value = {
            // firstName: res?.data?.firstName || res?.data?.fullName,
            firstName: res?.data?.firstName,
            lastName: res?.data?.lastName,
            bio: res?.data?.bio,
            email: res?.data?.email,
            // address: res?.data?.address,
            mobileNo: res?.data?.mobileNo,
            dialCode: res?.data?.dialCode ? res?.data?.dialCode : "+1",
            image: res?.data?.image,
            role: res?.data?.role,
            gender: res?.data?.gender,
            id: res?.data?.id,
            bio: res?.data?.bio,
          };
          setDetail(value);
          setform(value);
        }
        loader(false);
      });
    }
    getRoles();
  }, [id]);

  return (
    <>
      <Html
        form={form}
        detail={detail}
        emailCheck={emailCheck}
        emailLoader={emailLoader}
        emailErr={emailErr}
        back={back}
        setEyes={setEyes}
        eyes={eyes}
        role={role}
        setform={setform}
        roles={roles}
        submitted={submitted}
        images={images}
        addressResult={addressResult}
        handleSubmit={handleSubmit}
        imageResult={imageResult}
        getError={getError}
      />
    </>
  );
};

export default AddEditUser;
